import { CLIENTS } from "./data";

const Row = ({ hidden }) => (
  <div className="marquee-track flex shrink-0 items-center" aria-hidden={hidden}>
    {CLIENTS.map((c) => (
      <span key={c} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-4xl font-bold tracking-tight text-black transition-colors duration-500 hover:text-white sm:text-6xl lg:text-7xl">
          {c}
        </span>
        <svg viewBox="0 0 20 20" className="h-6 w-6 shrink-0 text-black sm:h-8 sm:w-8">
          <path d="M10 0l2.4 7.6L20 10l-7.6 2.4L10 20l-2.4-7.6L0 10l7.6-2.4z" fill="currentColor" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="clients-marquee" className="relative border-y-2 border-black bg-brand-400 py-12 sm:py-16">
    <div className="mx-auto mb-8 flex max-w-[1440px] items-center justify-between px-5 lg:px-12">
      <span className="font-mono text-xs font-bold uppercase tracking-[0.22em] text-black">Trusted by</span>
      <span className="hidden font-mono text-xs uppercase tracking-[0.22em] text-neutral-800 sm:inline">A few of the names we keep clean</span>
    </div>
    <div className="marquee-mask flex overflow-hidden">
      <Row />
      <Row hidden />
    </div>
  </section>
);
